import { useState } from 'react';

interface Question {
  id: number;
  question: string;
  options: { text: string; value: string; icon: string }[];
}

const questions: Question[] = [
  {
    id: 1,
    question: 'Какой у вас опыт игры в казино?',
    options: [
      { text: 'Новичок', value: 'beginner', icon: 'ri-seedling-line' },
      { text: 'Средний', value: 'intermediate', icon: 'ri-user-line' },
      { text: 'Опытный', value: 'expert', icon: 'ri-vip-crown-line' }
    ]
  },
  {
    id: 2,
    question: 'Какой размер ставок вы предпочитаете?',
    options: [
      { text: 'Низкие (50-200₽)', value: 'low', icon: 'ri-coin-line' },
      { text: 'Средние (200-1000₽)', value: 'medium', icon: 'ri-coins-line' },
      { text: 'Высокие (1000₽+)', value: 'high', icon: 'ri-money-dollar-circle-line' }
    ]
  },
  {
    id: 3,
    question: 'Какие игры вас интересуют?',
    options: [
      { text: 'Рулетка', value: 'roulette', icon: 'ri-contrast-drop-line' },
      { text: 'Блэкджек', value: 'blackjack', icon: 'ri-playing-card-line' },
      { text: 'Игровые шоу', value: 'gameshow', icon: 'ri-gamepad-line' }
    ]
  }
];

export default function QuizSection() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = (value: string) => {
    const newAnswers = { ...answers, [currentQuestion]: value };
    setAnswers(newAnswers);

    if (currentQuestion < questions.length - 1) {
      setTimeout(() => setCurrentQuestion(currentQuestion + 1), 300);
    } else {
      setTimeout(() => setShowResult(true), 300);
    }
  };

  const getRecommendation = () => {
    const experience = answers[0];
    const betSize = answers[1];
    const gameType = answers[2];

    if (experience === 'beginner' && betSize === 'low') {
      return { casino: 'SOL', bonus: 'Приветственный бонус 100% + низкие лимиты' };
    } else if (experience === 'expert' && betSize === 'high') {
      return { casino: 'IRWIN', bonus: 'VIP программа + персональный менеджер' };
    } else if (gameType === 'gameshow') {
      return { casino: 'STARDA', bonus: 'Лучшая коллекция игровых шоу от Evolution' };
    } else {
      return { casino: 'Flagman', bonus: 'Универсальный выбор для всех типов игроков' };
    }
  };

  const restart = () => {
    setCurrentQuestion(0);
    setAnswers({});
    setShowResult(false);
  };

  const progress = ((currentQuestion + 1) / questions.length) * 100;

  return (
    <section className="py-20 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12 animate-on-scroll opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Подберите идеальное казино</h2>
          <p className="text-gray-400">Пройдите короткий тест и получите персональную рекомендацию</p>
        </div>

        <div className="bg-[#242429] rounded-3xl p-8 shadow-2xl animate-on-scroll opacity-0">
          {!showResult ? (
            <>
              <div className="mb-8">
                <div className="h-2 bg-[#1a1a1f] rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] transition-all duration-500"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <div className="text-sm text-gray-400 mt-2 text-center">
                  Вопрос {currentQuestion + 1} из {questions.length}
                </div>
              </div>

              <h3 className="text-2xl font-bold mb-8 text-center">
                {questions[currentQuestion].question}
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {questions[currentQuestion].options.map((option, index) => (
                  <button
                    key={index}
                    onClick={() => handleAnswer(option.value)}
                    className="bg-[#1a1a1f] rounded-2xl p-6 hover:bg-gradient-to-br hover:from-[#d4af37]/20 hover:to-[#f4d03f]/20 hover:scale-105 transition-all duration-300 group"
                  >
                    <i className={`${option.icon} text-5xl text-[#d4af37] mb-4 block group-hover:scale-110 transition-transform`}></i>
                    <div className="text-lg font-semibold">{option.text}</div>
                  </button>
                ))}
              </div>
            </>
          ) : (
            <div className="text-center animate-fade-in">
              <div className="w-20 h-20 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-trophy-line text-4xl text-black"></i>
              </div>
              
              <h3 className="text-3xl font-bold mb-4">Ваша рекомендация готова!</h3>
              
              <div className="bg-[#1a1a1f] rounded-2xl p-8 mb-6">
                <div className="text-[#d4af37] text-sm mb-2">Рекомендуем казино:</div>
                <div className="text-4xl font-bold mb-4">{getRecommendation().casino}</div>
                <p className="text-gray-300">{getRecommendation().bonus}</p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={restart}
                  className="bg-transparent border-2 border-[#d4af37] text-[#d4af37] font-semibold py-3 px-6 rounded-full hover:bg-[#d4af37] hover:text-black transition-all duration-300 whitespace-nowrap"
                >
                  Пройти заново
                </button>
                <a
                  href="#rating"
                  className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold py-3 px-6 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 whitespace-nowrap"
                >
                  Перейти в казино
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}